import React from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (val: boolean) => void;
  label?: string;
}

export const Toggle: React.FC<ToggleProps> = ({ checked, onChange, label }) => (
  <button
    onClick={() => onChange(!checked)}
    className={`
      flex items-center px-3 py-2 min-h-[44px] min-w-[44px] md:min-h-0 md:min-w-0 md:px-2.5 md:py-1
      rounded-lg text-xs font-bold transition-all duration-200 ease-out border active:scale-[0.95] shadow-sm
      ${checked
        ? 'bg-emerald-500/15 border-emerald-500/50 text-emerald-400 active:bg-emerald-500/30 lg:hover:bg-emerald-500/25 lg:hover:border-emerald-500/60 shadow-emerald-500/10'
        : 'bg-dark-input/80 border-dark-border/30 text-dark-muted active:border-dark-border/30 lg:hover:border-dark-border/30 lg:hover:bg-dark-input'}
    `}
    data-testid='unknown-action-btn'
    data-ux='action'
    data-interaction-id='unknown-action-btn'>
    {checked && <span className="mr-1">✓</span>}
    {label || (checked ? 'On' : 'Off')}
  </button>
);
